import { useState, useContext, useEffect } from 'react';
import FormContext from '../contexts/form/formContext';
import { AlertComp } from './Layouts/Alert';
import SchoolInfo from './SchoolInfo';
import StudentSelect from './StudentSelect';

const FormComp = () => {
  const {
    addRegDetails,
    participants,
    studentCountValue,
    regDetails,
    submitForm,
    clearState,
  } = useContext(FormContext);

  const [schoolName, setSchoolName] = useState('');

  const [btn, setBtn] = useState(false);

  const [alertMessage, setAlertMessage] = useState({
    alert: false,
    message: '',
    title: '',
  });

  const fillForm = (e) => {
    setSchoolName(e.target.value);
  };

  const addRegistration = async () => {
    if (schoolName === '') {
      return setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Error',
        message: 'Enter school name',
      }));
    }
    addRegDetails({ schoolName });
    setBtn(true);

    setTimeout(() => {
      setSchoolName('');
      setBtn(false);
    }, 3000);
  };

  useEffect(() => {
    if (regDetails !== null && participants.length > 0) {
      submitForm(regDetails, participants);
      clearState();
    }

    //eslint-disable-next-line
  }, [regDetails, participants]);

  return (
    <div className="w-auto px-2 py-8">
      {alertMessage.alert && (
        <AlertComp
          alertMessage={alertMessage}
          setAlertMessage={setAlertMessage}
        />
      )}

      <SchoolInfo schoolName={schoolName} fillForm={fillForm} />
      <br />
      <StudentSelect />
      <br />
      {participants.length === studentCountValue && participants.length !== 0 && (
        <button
          className="w-full p-3 bg-cyan-400 hover:bg-cyan-500 rounded-lg my-5 text-2xl"
          onClick={addRegistration}
          disabled={btn}
        >
          submit passport(s)
        </button>
      )}
    </div>
  );
};

export default FormComp;
